import { PersistentChatWithMessages } from "~shared/types/persistent-chat-types";

export const NEW_CHAT_ID = "new-chat" as const;

/** React Query key for a chat; includes projectId so optimistic / new-chat cache cannot bleed across projects. */
export const chatQueryKey = (projectId: string, chatId: string) => ["chat", projectId, chatId] as const;

export const DefaultChatModel: PersistentChatWithMessages = {
  id: NEW_CHAT_ID,
  messages: [],
  project_id: "",
  user_id: "",
  created_at: new Date(),
  updated_at: new Date(),
  title: "Untitled Chat",
  active_leaf_message_id: null,
  messagePagination: null,
};

/** User turns loaded per page for agentic Story Chat history. */
export const CHAT_RECENT_TURN_LIMIT = 10;
